import { useState, useEffect } from "react";
import { Box, Button, Card, CardContent, Divider, TextField, Typography, useColorScheme, useMediaQuery, useTheme } from "@mui/material";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Tooltip from '@mui/material/Tooltip';
import { findSettings, setSettings } from "../../../utils/settings/fetchSettings";
import { auth } from "../../../../contexts/authentication";
import FormGroup from '@mui/material/FormGroup';
import Switch from '@mui/material/Switch';
// import SettingsTypebotModal from "./SettingsTypebotModal";
import SettingsTypebotModal from "./SettingsTypebotModal";
import { useTypebotId } from "../../../../contexts/TypebotIdContext";
import { findAllTypebots, findTypebot } from "../../../utils/typebot/fetchTypebot";
import SuccessAlert from "../../../components/SucessAlert";
import LoadingLinear from "../../../components/LoadingLinear";

export default function Typebot() {
  const [showModal, setShowModal] = useState(false);
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [loading, setLoading] = useState(true);
  const [tpData, setTpData] = useState([]);
  const { typebotId, setTypebotId } = useTypebotId();
  const [mode, setMode] = useState<'create' | 'update'>('create');
  const currentUser = auth.currentUser;
  const uid = currentUser?.uid;

  const theme = useTheme();
  const currentTheme = theme.palette.mode;
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

  useEffect(() => {
    if (showSuccessAlert) {
      setTimeout(() => {
        setShowSuccessAlert(false)
      }, 6000)
    }
  }, [showSuccessAlert])

  useEffect(() => {
    const getAllTypebots = async () => {
      try {
        const data = await findAllTypebots(uid);
        setTpData(data);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.error('Erro ao encontrar Typebot:', error);
      }
    }
    getAllTypebots();
  }, [typebotId, tpData]);

  return (
    <CardContent sx={{ flexGrow: 1, p: '24px !important' }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
        <Box>
          <Button
            variant="contained"
            onClick={() => {
              setShowModal(true);
              setMode('create');
            }}
          >
            Criar novo assistente
          </Button>
        </Box>
        {loading ? (
          <LoadingLinear />
        ) : tpData && tpData.length > 0 ? (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Typography variant="body2">
              Assistentes criados:
            </Typography>
            {tpData.map((item: any) => (
              <Card
                key={item.id}
                className="typebot-item"
                onClick={() => {
                  setShowModal(true);
                  setMode('update');
                  setTypebotId(item.id);
                }}
                sx={{
                  '&:hover': {
                    backgroundColor: currentTheme === 'dark' ? '#191a276b' : '#c9dfff47',
                  },
                  cursor: 'pointer',
                }}
              >
                <Typography variant="body2" color='text.secondary'>
                  {item.description}
                </Typography>
                {isDesktop && (
                  <Typography variant="body2" color='text.secondary' fontSize={12}>
                    {item.url}/{item.typebot}
                  </Typography>
                )}
              </Card>
            ))}
          </Box>
        ) : (
          <Typography variant="body2" sx={{ color: 'text.secondary', mt: 2 }}>
            Nenhum assistente criado.
          </Typography>
        )}
      </Box>
      {showModal &&
        <SettingsTypebotModal
          showModal={showModal}
          setShowModal={setShowModal}
          setShowSuccessAlert={setShowSuccessAlert}
          setSuccessMessage={setSuccessMessage}
          mode={mode}
        />
      }
      {showSuccessAlert && (
        <SuccessAlert message={successMessage} />
      )}
    </CardContent>
  );
}